import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../utils/metaPixel';
interface CTAButtonProps {
  children: React.ReactNode;
  subtitle?: string;
  large?: boolean;
  scrollTo?: string;
  href?: string;
}
export function CTAButton({
  children,
  subtitle,
  large = false,
  scrollTo,
  href
}: CTAButtonProps) {
  const baseClass = `inline-block text-center no-underline bg-gradient-to-r from-rose-gold to-burgundy text-white font-bold rounded-full shadow-lg hover:shadow-2xl transition-shadow w-full max-w-md cursor-pointer ${large ? 'px-6 py-3.5 text-base sm:px-8 sm:py-4 sm:text-lg md:px-12 md:py-5 md:text-xl' : 'px-5 py-3 text-sm sm:px-6 sm:py-3.5 sm:text-base md:px-10 md:py-4 md:text-lg'}`;
  const handleScrollClick = (e: React.MouseEvent) => {
    if (scrollTo) {
      e.preventDefault();
      const el = document.getElementById(scrollTo);
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  };
  const handleCheckoutClick = () => {
    trackAddToCart();
  };
  return <div className="flex flex-col items-center gap-1.5 md:gap-2 px-2" data-id="element-52">
      {scrollTo ? <motion.a href={`#${scrollTo}`} onClick={handleScrollClick} className={baseClass} whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.98
    }} data-id="element-53">
          {children}
        </motion.a> : <motion.a href={href || 'https://redevenirmoi.com/cart/53565420372336:1'} target="_blank" rel="noopener noreferrer" onClick={handleCheckoutClick} className={baseClass} whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.98
    }} data-id="element-54">
          {children}
        </motion.a>}
      {subtitle && <p className="text-xs sm:text-sm text-gray-600 font-lato text-center" data-id="element-55">
          {subtitle}
        </p>}
    </div>;
}